// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_className__uZeQd {
    width: calc(100% - 60px);

}

.style_className__uZeQd>div {}

.style_className__uZeQd input {
    height: 25px;
}

.style_input__hzgwf {
    width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AppSearch/style.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;;AAE5B;;AAEA,6BAAgB;;AAEhB;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".className {\n    width: calc(100% - 60px);\n\n}\n\n.className>div {}\n\n.className input {\n    height: 25px;\n}\n\n.input {\n    width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"className": `style_className__uZeQd`,
	"input": `style_input__hzgwf`
};
export default ___CSS_LOADER_EXPORT___;
